import React, { useContext, useEffect, useState, useCallback } from "react";
import css from "./header.module.scss";
import { TraineeDropdown } from "../../components/Header/components";
import { withSiteContext, withUserContext, withApiContext } from "context";
import CircularProgressBar from "re_redesigned_componnents/circular_progressBar/CircularProgressBar";
import { useMediaQuery, IconButton, Badge } from "@mui/material";
import { DashboardContext } from "re_redesigned_componnents/context/Context";
import {
  IconMenu,
  IconMailNew,
  IconNotification,
} from "re_redesigned_componnents/icon";
import RatingButton from "components/RatingButton/RatingButton";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { subscribeDirectChat } from "services/chatSocket";
import { useDirectChatModal } from "re_designed_pages/DirectChat/DirectChatModalProvider";

function Header(props) {
  const { openDirectChat } = useDirectChatModal();
  const { setToggle, setShowMenu } = useContext(DashboardContext);
  const isLargeScreen = useMediaQuery("(min-width:767px)");
  const [directUnread, setDirectUnread] = useState(0);

  const logo =
    !props.loggedIn && props.ctx_site.site?.logo
      ? props.ctx_site.site.logo
      : props.ctx_user.user?.logo
        ? props.ctx_user.user.logo
        : null;
  const campusLogo =
    props.loggedIn && props.ctx_user.user?.coBrand
      ? props.ctx_user.user.coBrand.image
      : !props.loggedIn && props.ctx_site.site.coBrandImage
        ? props.ctx_site.site.coBrandImage
        : null;
  const campusList = props.loggedIn ? props.ctx_user.user.campusList : null;
  const organizationId = props.loggedIn
    ? props.ctx_user.user.organizationId
    : null;
  const roleId = props.loggedIn ? props.ctx_user.user.roleId : null;
  const campus =
    props.loggedIn &&
    campusList.find((d) => d.campus_role_id == `${organizationId} : ${roleId}`);
  const title = props.loggedIn
    ? campus
      ? campus.organization_nm
      : props.ctx_site.site.siteName
    : props.ctx_site.site.siteName;

  const showHelpdesk =
    campus &&
    (campus.member_type === 1 ||
      campus.member_type === 2 ||
      campus.member_type === 3);

  const loadDirectUnread = useCallback(() => {
    if (!props.loggedIn || !organizationId || campus?.member_type !== 2) {
      setDirectUnread(0);
      return;
    }
    props.ctx_api
      .privateRequest({
        cmd: "chat_unread_count",
        args: { organizationId },
      })
      .then(({ rsp }) => {
        if (rsp && typeof rsp.count === "number") {
          setDirectUnread(rsp.count);
        }
      })
      .catch(() => {});
  }, [props.loggedIn, props.ctx_api, organizationId, campus?.member_type]);

  useEffect(() => {
    loadDirectUnread();
    const id = setInterval(loadDirectUnread, 45000);
    return () => clearInterval(id);
  }, [loadDirectUnread]);

  useEffect(() => {
    if (campus?.member_type !== 2) return undefined;
    return subscribeDirectChat({
      onMessage: loadDirectUnread,
      onRead: loadDirectUnread,
    });
  }, [campus?.member_type, loadDirectUnread]);

  useEffect(() => {
    if (campus?.member_type !== 2) return undefined;
    const onUnreadChanged = () => loadDirectUnread();
    window.addEventListener("directChat:unreadChanged", onUnreadChanged);
    return () => window.removeEventListener("directChat:unreadChanged", onUnreadChanged);
  }, [campus?.member_type, loadDirectUnread]);

  const toggleVisibility = () => {
    setToggle((prev) => {
      return !prev;
    });
  };
  const menuVisibility = () => {
    setShowMenu((prev) => !prev);
  };

  return (
    <div className={css.header_wrap}>
      <div className={css.header_name}>
        <img src={logo} alt="DP" />
        <h1>{title}</h1>
      </div>
      {showHelpdesk || !isLargeScreen ? (
        <div className={css.header_actions}>
          {showHelpdesk ? <RatingButton variant="nav" /> : null}
          {showHelpdesk && campus?.member_type === 2 ? (
            <IconButton
              onClick={() => openDirectChat({})}
              aria-label="Messages"
              size="large"
            >
              <Badge
                badgeContent={directUnread}
                color="error"
                overlap="rectangular"
                max={99}
                invisible={directUnread === 0}
              >
                <ChatBubbleOutlineIcon />
              </Badge>
            </IconButton>
          ) : null}
          {!isLargeScreen ? (
            <>
              <IconNotification></IconNotification>
              <IconMailNew></IconMailNew>
              <div onClick={toggleVisibility}>
                <CircularProgressBar
                  size={45}
                  strokeWidth={4}
                  color={"#e6e6e6"}
                >
                  <img
                    id={css.profile_pic}
                    src={props.ctx_user.user.photo}
                    alt=""
                  />
                </CircularProgressBar>
              </div>
            </>
          ) : null}
        </div>
      ) : null}
      <TraineeDropdown
        acadYearName={campus ? campus.acad_year_name : null}
        orgName={
          campus ? `${campus.organization_name} - ${campus.role_name}` : null
        }
        onOrgSwitch={props.onCampusSwitch}
      />
      {isLargeScreen && <img src={campusLogo} alt="DP" />}
      {!isLargeScreen && <IconMenu onClick={menuVisibility}></IconMenu>}
    </div>
  );
}

export default withSiteContext(withUserContext(withApiContext(Header)));
